import { TFunction } from 'i18next';
import { Option } from '@lib/interfaces/form';
import Select from '@lib/components/Select/Select';
import ButtonControl from '@lib/components/Select/components/ButtonControl';
import ButtonValueContainer from '@lib/components/Select/components/ButtonValueContainer';
import ValidityHintOption from '@lib/components/Select/components/ValidityHintOption';
import { ButtonSizes, ButtonTypes } from '@lib/components/Button/Button';
import getValidityHintOptions from '../../utils/getValidityHintOptions';

type Props = {
  t: TFunction<'translation', undefined>;
  value: Option[];
  onChange: (value: Option[]) => void;
};

export default function CompletionStatusFilter({ t, value, onChange }: Props) {
  const options = getValidityHintOptions();

  return (
    <Select
      name="daily-inspection-status-filter"
      isMulti
      isClearable={false}
      isSearchable={false}
      options={options}
      value={value}
      values={value}
      onChange={(v) => onChange((v as Option[]) || [])}
      components={{
        Control: ButtonControl,
        ValueContainer: ButtonValueContainer,
        Option: ValidityHintOption,
      }}
      buttonControlProps={{
        buttonText: t('status'),
        buttonType: ButtonTypes.secondaryOutlined,
        buttonSize: ButtonSizes.small,
      }}
      fullWidthMenu={false}
      usePortal
    />
  );
}
